export default "__VITE_ASSET__ComIm8Bq__"